<template>
	<div class="p-x-20 p-y-12 bg-white">
		<div class="d-flex-between-center">
			<div class="d-block">
				<div class="f-regular f-14 f-c-midgrey">
					{{ title }}
				</div>
				<div class="f-bold f-16">
					{{ value }}
				</div>
				<div class="f-16" v-html="subvalue"></div>
			</div>
			<div v-if="!hideIcon" class="align-items-center" @click="edit">
				<img src="../../../assets/icons/edit_2.svg" alt="">
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "SOMenuItemEdit",
	props: {
		title: String,
		value: String,
		subvalue: {
			type: String,
			default: "",
		},
		hideIcon: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		edit(payload) {
			this.$emit("edit", payload)
		}
	}
}
</script>